import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useDispatch, useSelector } from 'react-redux';
//UI
const Navbar = React.lazy(() => import('./components/Navbar'));
const Destinations = React.lazy(() => import('./components/Destinations'));
const ContactUs = React.lazy(() => import('../../components/contactus/ContactUs'));
const Footer = React.lazy(() => import('./components/Footer'));
import MainLoader from '../../components/Loaders/MainLoader';
//SLICE
import { getYachtsThunk, initialStateYacht } from '../../store/slices/catalogs/yacht.slice';
import { getScreenAdminThunk, initialStatePage } from '../../store/slices/pages/page.slice';
import { getDestinationsThunk, initialStateDestination } from '../../store/slices/catalogs/destination.slice';
import { scrollToTop } from '../../utils/funtions';

const DestinationsPage = () => {

  const dispatch = useDispatch();
  const yachtState = useSelector(state => state.yachts);
  const islandState = useSelector(state => state.page);
  const destinationState = useSelector(state => state.destinations);
  const isLoading = useSelector(state => state.isLoadingSlice);

  useEffect(() => {
    scrollToTop();
    dispatch(getScreenAdminThunk('galapagos-islands'));
    dispatch(getDestinationsThunk());
    dispatch(getYachtsThunk())
    return () => {
      dispatch(initialStateYacht());
      dispatch(initialStatePage());
      dispatch(initialStateDestination());
    }
  }, []);

  return (
    <div className='bg-white'>
      <Helmet>
        <title>About the Galapagos | Wildlife & Nature Travel Guide – Rolf Wittmer</title>
        <meta name="description" content="Learn about the unique biodiversity, volcanic landscapes, and iconic wildlife that make the Galapagos Islands a must-visit destination." />
      </Helmet>
      {
        isLoading || yachtState.fetching || destinationState.fetching || islandState.page?.sections === undefined ? <MainLoader /> :
          <>
            <Navbar yachtState={yachtState.yachts} />
            <Destinations
              islandState={islandState.page}
              destinationState={destinationState.destinations}
            />
             <ContactUs />
             <Footer />
          </>
      }
    </div>
  );
};

export default DestinationsPage;